import { GET, POST } from './api'

const table = '/send-email/pending-access'

function normalizeApprovalResponse(result) {
  if (!result) {
    return {
      ok: false,
      status: 0,
      data: {
        error: true,
        message: 'Network error. Please try again.',
      },
    }
  }

  return {
    ok: !result?.error,
    status: result?.error?.status || result?.status || (result?.error ? 400 : 200),
    data: result,
  }
}

async function requestApproval(path, method, token, body) {
  const queryToken = encodeURIComponent(String(token || ''))
  const pathWithToken = `${path}${path.includes('?') ? '&' : '?'}token=${queryToken}`
  const result = method === 'GET'
    ? await GET(pathWithToken)
    : await POST(pathWithToken, body || {}, false)

  return normalizeApprovalResponse(result)
}

export const ReadPendingAccess = async (token) => {
  return await requestApproval(table, 'GET', token)
}

export const ReadPendingIdentityReview = async (token, id, companyName, accountId) => requestApproval(`${table}?options=identity&id=${encodeURIComponent(id)}${companyName !== undefined ? `&companyName=${encodeURIComponent(companyName)}` : ''}${accountId ? `&accountId=${encodeURIComponent(accountId)}` : ''}`, 'GET', token)

export const ReadMyPendingIdentityReview = async (id, companyName, accountId) => normalizeApprovalResponse(await GET(
  `/send-email/my-pending-access?options=identity&id=${encodeURIComponent(id)}${companyName !== undefined ? `&companyName=${encodeURIComponent(companyName)}` : ''}${accountId ? `&accountId=${encodeURIComponent(accountId)}` : ''}`, true
))

export const ReadPendingAccessCompanies = async (token, params = {}) => {
  const query = new URLSearchParams({
    token: String(token || ''),
    options: 'companies',
    query: String(params.query || ''),
    page: String(params.page || 1),
    pageSize: String(params.pageSize || 30),
  })
  return await GET(`${table}?${query.toString()}`)
}

export const ApprovePendingAccess = async (token, id, companyId, useRegistrationCompany = false, companyEdit = {}) => {
  return await requestApproval(`${table}/approve/${id}`, 'POST', token, companyEdit.approvalMode === 'automatic' ? { approvalMode: 'automatic' } : companyEdit.partnerAccountId ? { partnerAccountId: companyEdit.partnerAccountId, ...(companyEdit.editCompanyName ? { editCompanyName: true, companyName: companyEdit.companyName } : {}) } : companyEdit.salesforceReview ? { salesforceReview: companyEdit.salesforceReview } : companyEdit.editCompanyName
    ? { editCompanyName: true, companyName: companyEdit.companyName }
    : useRegistrationCompany ? { useRegistrationCompany: true } : companyId ? { companyId } : {})
}

export const RejectPendingAccess = async (token, id) => {
  return await requestApproval(`${table}/reject/${id}`, 'POST', token, {})
}

function buildAuthenticatedPendingAccessQuery({ page = 1, pageSize = 10, search = '' } = {}) {
  const query = new URLSearchParams({
    page: String(page),
    pageSize: String(pageSize),
  })
  if (String(search || '').trim()) {
    query.set('search', String(search).trim())
  }
  return query.toString()
}

export const ReadMyPendingAccess = async (params) => {
  const result = await GET(`${table.replace('/pending-access', '/my-pending-access')}?${buildAuthenticatedPendingAccessQuery(params)}`, true)
  return normalizeApprovalResponse(result)
}

export const ReadMyPendingAccessCompanies = async (params = {}) => {
  const query = new URLSearchParams({
    options: 'companies',
    query: String(params.query || ''),
    page: String(params.page || 1),
    pageSize: String(params.pageSize || 30),
  })
  return await GET(`${table.replace('/pending-access', '/my-pending-access')}?${query.toString()}`, true)
}

export const ApproveMyPendingAccess = async (id, companyId, useRegistrationCompany = false, companyEdit = {}) => {
  const result = await POST(
    `${table.replace('/pending-access', '/my-pending-access')}/approve/${id}`,
    companyEdit.approvalMode === 'automatic' ? { approvalMode: 'automatic' } : companyEdit.partnerAccountId ? { partnerAccountId: companyEdit.partnerAccountId, ...(companyEdit.editCompanyName ? { editCompanyName: true, companyName: companyEdit.companyName } : {}) } : companyEdit.salesforceReview ? { salesforceReview: companyEdit.salesforceReview } : companyEdit.editCompanyName ? { editCompanyName: true, companyName: companyEdit.companyName }
      : useRegistrationCompany ? { useRegistrationCompany: true } : companyId ? { companyId } : {},
    true
  )
  return normalizeApprovalResponse(result)
}

export const RejectMyPendingAccess = async (id) => {
  const result = await POST(`${table.replace('/pending-access', '/my-pending-access')}/reject/${id}`, {}, true)
  return normalizeApprovalResponse(result)
}

export { buildAuthenticatedPendingAccessQuery, normalizeApprovalResponse }
